import { automationErrorsSelector } from "./automationErrorsSelector";
import { RootState } from "../../../../store";

export const automationRegionsErrorSelector = (state: RootState) => {
  const errors = automationErrorsSelector(state);

  return errors.regions;
};
